export default function autoSuggestion(): void {
  // Helper to remove any existing dropdowns
  const removeDropdown = () => {
    document.querySelectorAll(".autocomplete-dropdown").forEach(el => el.remove());
  };

  // Create and show the dropdown
  const showDropdown = (input: HTMLInputElement, list: string[]) => {
    removeDropdown();

    //console.log("showDropdown", list);

    const rect = input.getBoundingClientRect();
    const dropdown = document.createElement("ul");
    dropdown.className = "autocomplete-dropdown";
    dropdown.style.position = "absolute";
    dropdown.style.left = `${rect.left + window.scrollX}px`;
    dropdown.style.top = `${rect.bottom + window.scrollY}px`;
    dropdown.style.width = `${rect.width}px`;
    dropdown.style.border = "1px solid #ccc";
    dropdown.style.backgroundColor = "#fff";
    dropdown.style.zIndex = "1000";
    dropdown.style.listStyle = "none";
    dropdown.style.padding = "0";
    dropdown.style.margin = "0";

    list.forEach((item) => {
      const li = document.createElement("li");
      li.textContent = item;
      li.style.padding = "6px 10px";
      li.style.cursor = "pointer";

      li.addEventListener("mousedown", (event) => {
        event.preventDefault();

        const currentValue = input.value;
        const selected = item;

        if ((event as MouseEvent).ctrlKey) {
          // Handle multi-select with comma
          if (currentValue.includes(",")) {
            const parts = currentValue.split(",");
            parts[parts.length - 1] = selected;
            input.value = parts.join(", ");
          } else if (currentValue.trim().length > 0) {
            input.value = currentValue + ", " + selected;
          } else {
            input.value = selected;
          }
        } else {
          input.value = selected;
        }

        input.dispatchEvent(new Event("change"));
        input.focus();
        removeDropdown();
      });

      dropdown.appendChild(li);
    });

    document.body.appendChild(dropdown);
  };

  // Main event binding
  document.querySelectorAll<HTMLInputElement>(".slist").forEach((input) => {
    const rawData = input.getAttribute("data-list") ?? "";
    const allItems = rawData
      .split(";")
      .map((v) => v.trim())
      .filter(Boolean);

    input.addEventListener("focus", () => {
      showDropdown(input, allItems);
    });

    input.addEventListener("input", () => {
      const val = input.value.toLowerCase();
      const currentPart = val.includes(",")
        ? val.split(",").pop()?.trim() ?? ""
        : val;

      const filtered = allItems.filter((item) =>
        item.toLowerCase().startsWith(currentPart)
      );

      showDropdown(input, filtered);
    });

    input.addEventListener("blur", () => {
      setTimeout(removeDropdown, 200); // Allow click to register before removal
    });
  });
}

// Call this function after DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  autoSuggestion();
});
